import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/web/sapient.pro/private/sapientpro-frontend/src/app/(pages)/ClientOnlyParts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/web/sapient.pro/private/sapientpro-frontend/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/web/sapient.pro/private/sapientpro-frontend/src/components/Header/Header.tsx");
